import React from 'react';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import { classnames } from '../../../../utils/classnames';
import ItemCardActions from '../itemCard/components/itemCardActions/itemCardActions';
import { Status } from '../../../ui/index';
import './orderCard.css';
import Icon from '../../ui/icon/icon';
import { ImageEvent } from '../eventCard/eventCard';

function OrderCardLine({icon, text}) {
    return (
        <div className='neo-order-card-line-content'>
            <div className='neo-order-line-icon-container'>
                <Icon className='neo-order-line-icon' name={icon}/>
            </div>
            <div className='neo-order-line-text'>{text}</div>
        </div>
    )
}

function FormatedDate({label, date, locale}) {
    const { t } = useTranslation();
    return (
        <div className='neo-order-card-date'>
            <div className='neo-order-card-date-text'>{t(label)}</div>
            <div>
                {new Date (date).toLocaleString(locale, {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                })}
            </div>
        </div>
    )
}

function ShowMoreItem({icon, children}) {
    return (
        <div className='neo-order-card-show-more-item'>
            <Icon name={icon}/>
            {children}
        </div>
    )
}

export default function OrderCard({order, event = null, action = null, children }) {
    const { t } = useTranslation();
    const locale = i18n.language;
    const [showMore, setShowMore] = React.useState(false);

    const status = React.useMemo(() => {
        if (order.status === 'valid') {
            return 'green';
        } 
        if (order.status === 'reservation') {
            return 'orange'
        } 
        if (order.status === 'deleted') {
            return 'red';
        } 
        return 'grey';
    }, [order]);

    const full_address = React.useMemo(() => {
        if (!event.address) return '';
        const {address1, address2, name, zip_code, city, state, country} = event.address;
        const elements = [
            address1,
            address2,
            name,
            `${zip_code || ''}${zip_code && city ? ' ' : ''}${city || ''}`,
            state,
            country
        ];
        return elements.filter(a => a).join(', ');
    }, [event]);

    const _infosAction = React.useMemo(() => {
        if (children) {
            return {
                label: t('widget.item-card.informations'),
                icon: "infoCircle",
                onClick: () => setShowMore(state => !state)
            }
        }
        return null;
    }, [children]);

    return (
        <div className={classnames('neo-order-card-container')}>
            <div className={classnames('neo-order-card')}>
                <div className='neo-order-card-left-container'>
                    <ImageEvent config={{event_header: {
                        full_picture: event.full_picture,
                    }}}/>
                    <div className='neo-order-card-infos'>
                        <div className='neo-order-card-title'>{order.event.name}</div>
                        <OrderCardLine icon='purchaseTag' text={order.transaction_reference}/>
                        <OrderCardLine icon='ticket' text={t(`widget.order-card.tickets`, {count: order.attendees_count})}/>
                        {status && 
                            <div className='neo-order-status-container'>
                                <Status color={status} text={t(`widget.order-card.status.${order.status}`)}/>
                            </div>
                        }
                    </div>
                </div>
                <div className='neo-order-card-right-container'>
                    <ItemCardActions mainAction={action} infosAction={_infosAction}/>
                </div>
            </div>
            {showMore && (
                <div className='neo-order-card-show-more'>
                    {(event.start_date || event.end_date) && (
                        <ShowMoreItem icon='calendar'>
                            <div>
                                {event.start_date && <FormatedDate date={event.start_date} label={'widget.order-card.start'} locale={locale}/>}
                                {event.end_date && <FormatedDate date={event.end_date} label={'widget.order-card.end'} locale={locale}/>}
                            </div>
                        </ShowMoreItem>
                    )}
                    { full_address && 
                        <ShowMoreItem icon='mapPin'>
                            <div>{full_address}</div>
                        </ShowMoreItem>
                    }
                    {children}
                </div>
            )}
        </div>
    )
}